import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../components/Login.vue";

Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    path: "/portal/:urlInstitucion",
    name: "LoginInstitucion",
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/Login.vue"),
    props: true,
  },
  {
    path: "/Register",
    name: "Register",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/Register.vue"),
  },
  {
    path: "/BuscarInstitucion",
    name: "BuscarInstitucion",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/Turnos/BuscarInstitucion.vue"
      ),
  },
  {
    path: "/MisTurnos",
    name: "MisTurnos",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/Turnos/MisTurnos.vue"
      ),
  },
  {
    path: "/ConfCuenta",
    name: "ConfCuenta",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/Cuenta/ConfCuenta.vue"
      ),
  },
  {
    path: "/Competiciones",
    name: "Competiciones",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/Torneos/ListaCompeticiones.vue"
      ),
  },
  {
    path: "/Home",
    name: "Home",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Home.vue"),
  },
  {
    path: "/Torneos",
    name: "Torneos",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/Torneos/Torneos.vue"
      ),
    props: true,
  },
  {
    path: "/Ligas",
    name: "Ligas",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/Torneos/Ligas.vue"
      ),
    props: true,
  },
    {
    path: "/Rankings",
    name: "Rankings",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/Rankings/Rankings.vue"
      ),
    props: true,
  },
  {
    path: "/PagoConfirmado",
    name: "PagoConfirmado",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/Turnos/PagoConfirmado.vue"
      ),
  },

  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  mode: "history",
  routes,
});

export default router;
